// @ts-nocheck
// Estudo 2.0 — Sheets (leitura longa, discussão, menu, edição, qbox, insight, tema).
import React, { useState, useEffect, useRef } from 'react';
import {
  IcoBack, IcoMore, IcoClose, IcoCheck, IcoTrophy, IcoChevron, IcoTeach, IcoLock, IcoCrown, IcoReply,
  IcoEdit, IcoTrash, IcoFlag, IcoSend, IcoTheme,
} from './icons2';
import {
  Avatar, RichText, REACTIONS, POST_TYPES, TypeBadge, Sheet, PrimaryBtn,
  fmt, parseLicao, isLicao, postHeat, readingTime,
} from './ui2';
import { HeatBadge, reactBtn, PostCard, useStudy } from './cards2';
import { ThreadView } from './threads2';

/* ---------- Container de tela cheia (slide-in) ---------- */
export function FullView({ onClose, title, right, children }: any) {
  useEffect(() => {
    const onKey = (e: any) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 70, background: 'var(--paper)', display: 'flex', flexDirection: 'column',
      maxWidth: 460, margin: '0 auto', animation: 'e2SlideIn 0.3s cubic-bezier(0.2,0.8,0.2,1) both',
    }}>
      <header style={{
        display: 'flex', alignItems: 'center', gap: 10, padding: 'calc(10px + var(--sat,0px)) 12px 10px', flexShrink: 0,
        borderBottom: '1px solid var(--line)', background: 'color-mix(in oklab, var(--paper) 88%, transparent)',
        backdropFilter: 'blur(10px)', position: 'sticky', top: 0, zIndex: 2,
      }}>
        <button onClick={onClose} style={{ width: 38, height: 38, borderRadius: 10, display: 'grid', placeItems: 'center', color: 'var(--ink-2)', background: 'var(--paper-2)' }}><IcoBack size={20} /></button>
        <div style={{ flex: 1, minWidth: 0 }}>{title}</div>
        {right}
      </header>
      <div style={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch' }}>{children}</div>
    </div>
  );
}

export function ThemeTagsStatic({ tags }: any) {
  if (!tags || !tags.length) return null;
  return (
    <div style={{ display: 'flex', gap: 5 }}>
      {tags.slice(0, 2).map((t: string) => (
        <span key={t} className="mono" style={{ fontSize: 10.5, color: 'var(--ink-3)', background: 'var(--paper-3)', padding: '3px 8px', borderRadius: 999 }}>{t}</span>
      ))}
    </div>
  );
}
export function ReactionBarStatic({ post, onReact }: any) {
  const { canPost } = useStudy() || {};
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      {REACTIONS.map((r: any) => {
        const active = (post.yourReactions || []).includes(r.id);
        const count = post.reactions?.[r.id] || 0; const Icon = r.Icon;
        return (
          <button key={r.id} onClick={() => onReact(post.id, r.id)} style={{ ...reactBtn(active, r.accent), flexDirection: 'column', gap: 3, padding: '8px 12px', fontSize: 11, opacity: canPost === false ? 0.45 : 1, cursor: canPost === false ? 'not-allowed' : 'pointer' }}>
            <Icon size={19} fill={active ? r.accent : 'none'} />
            <span>{count > 0 ? fmt(count) : r.label}</span>
          </button>
        );
      })}
    </div>
  );
}

function CommentsLoadingOrThread({ post, comments, commentsLoading, viewerId, title, onAddComment, onEditComment, onDeleteComment, onReactComment }: any) {
  if (commentsLoading) return <div style={{ textAlign: 'center', padding: '20px 0', color: 'var(--ink-4)', fontSize: 13.5 }}>Carregando discussão…</div>;
  return (
    <ThreadView comments={comments || []} viewerId={viewerId} title={title}
      onAddComment={(text: string, pid: string) => onAddComment(post.id, text, pid)}
      onEditComment={(cid: string, text: string) => onEditComment(post.id, cid, text)}
      onDeleteComment={(cid: string) => onDeleteComment(post.id, cid)}
      onReactComment={(cid: string, kind: string) => onReactComment(post.id, cid, kind)} />
  );
}

/* ---------- LEITURA LONGA ---------- */
export function ReadingSheet({ post, comments, commentsLoading, onClose, onReact, onAddComment, onEditComment, onDeleteComment, onReactComment, onMenu, viewerId }: any) {
  const { onOpenProfile } = useStudy() || {};
  const goAuthor = (e: any) => { e?.stopPropagation?.(); if (onOpenProfile && post.author?.id) onOpenProfile(post.author.id); };
  const lic = parseLicao(post.text);
  const heat = postHeat(post);
  const title = lic.isLicao ? lic.concept : ((post.text.match(/^##\s(.+)$/m) || [])[1] || 'Estudo');
  const body = lic.isLicao ? lic.body : (post.text || '').replace(/^##\s.+$/m, '').replace(/^\n+/, '');
  const learned = post.reactions?.aprendi || 0;
  const youLearned = (post.yourReactions || []).includes('aprendi');
  return (
    <FullView onClose={onClose}
      title={<span className="mono" style={{ fontSize: 11.5, color: 'var(--ink-3)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>{lic.isLicao ? 'Lição' : 'Estudo'} · {readingTime(post.text)}</span>}
      right={<button onClick={() => onMenu(post)} style={{ width: 38, height: 38, borderRadius: 10, display: 'grid', placeItems: 'center', color: 'var(--ink-3)' }}><IcoMore size={20} /></button>}>
      <div style={{ padding: '20px 20px 8px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
          {lic.isLicao
            ? <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: 'var(--lapis)', fontSize: 11, fontFamily: 'var(--font-mono)', letterSpacing: '0.05em', textTransform: 'uppercase', fontWeight: 600 }}><span style={{ width: 22, height: 22, borderRadius: 7, background: 'var(--lapis-soft)', display: 'grid', placeItems: 'center' }}><IcoTeach size={13} /></span>Lição{learned > 0 ? ` · ensinou ${fmt(learned)}` : ''}</span>
            : <><TypeBadge kind={post.kind} /><HeatBadge heat={heat} /></>}
        </div>
        {lic.isLicao && <div className="mono" style={{ fontSize: 11, color: 'var(--ink-3)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4 }}>ensina</div>}
        <h1 className="serif" style={{ margin: '0 0 14px', fontSize: 32, lineHeight: 1.26, color: 'var(--ink)', letterSpacing: '0.01em' }}>{title}</h1>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, paddingBottom: 16, borderBottom: '1px solid var(--line)' }}>
          <span onClick={goAuthor} style={{ cursor: onOpenProfile ? 'pointer' : 'default', lineHeight: 0, flexShrink: 0 }}><Avatar user={post.author} size={36} ring={post.author?.role === 'Admin' ? 'var(--ember)' : null} /></span>
          <div style={{ flex: 1 }}>
            <div onClick={goAuthor} style={{ fontWeight: 600, fontSize: 14, color: 'var(--ink)', cursor: onOpenProfile ? 'pointer' : 'default' }}>{post.author?.name}</div>
            <div className="mono" style={{ fontSize: 11, color: 'var(--ink-4)' }}>{post.timeAgo}{post.page ? ` · p. ${post.page}` : ''}</div>
          </div>
          <ThemeTagsStatic tags={post.tags} />
        </div>
      </div>
      <div style={{ padding: '4px 20px 8px', fontSize: 16.5, lineHeight: 1.72 }}>
        <RichText text={body} />
      </div>
      {lic.isLicao && (
        <div style={{ padding: '4px 20px 12px' }}>
          <button onClick={() => onReact(post.id, 'aprendi')} style={{
            width: '100%', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 9, padding: '14px',
            borderRadius: 14, fontSize: 15.5, fontWeight: 700, transition: 'all 0.2s',
            background: youLearned ? 'var(--lapis)' : 'var(--lapis-soft)', color: youLearned ? '#10201f' : 'var(--lapis)',
            border: `1px solid color-mix(in oklab, var(--lapis) 30%, transparent)`,
          }}>
            <span style={{ display: 'inline-flex' }}>{youLearned ? 'Você aprendeu com esta lição' : 'Aprendi com isso'}</span>
          </button>
          <div style={{ textAlign: 'center', fontSize: 12, color: 'var(--ink-4)', marginTop: 8 }}>{learned > 0 ? `${fmt(learned)} membros aprenderam com ${(post.author?.name || '').split(' ')[0]}` : 'seja o primeiro a aprender com esta lição'}</div>
        </div>
      )}
      <div style={{ padding: '8px 20px 14px', margin: '8px 0', borderTop: '1px solid var(--line)', borderBottom: '1px solid var(--line)' }}>
        <ReactionBarStatic post={post} onReact={onReact} />
      </div>
      <div style={{ padding: '8px 20px calc(40px + var(--sab,0px))' }}>
        <CommentsLoadingOrThread post={post} comments={comments} commentsLoading={commentsLoading} viewerId={viewerId}
          title={lic.isLicao ? 'Dúvidas & outras explicações' : 'Discussão'}
          onAddComment={onAddComment} onEditComment={onEditComment} onDeleteComment={onDeleteComment} onReactComment={onReactComment} />
      </div>
    </FullView>
  );
}

/* ---------- DISCUSSÃO (bottom sheet) ---------- */
export function CommentsSheet({ post, comments, commentsLoading, onClose, onReact, onAddComment, onEditComment, onDeleteComment, onReactComment, viewerId, clubBook }: any) {
  return (
    <Sheet open={true} onClose={onClose} label="Discussão" maxHeight="92vh">
      <div style={{ display: 'flex', flexDirection: 'column', maxHeight: '92vh' }}>
        <div style={{ padding: '6px 18px 14px', borderBottom: '1px solid var(--line)', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <TypeBadge kind={post.kind} />
            <div style={{ flex: 1 }} />
            <button onClick={onClose} style={{ color: 'var(--ink-4)', padding: 4 }}><IcoClose size={20} /></button>
          </div>
          <PostPreview post={post} clubBook={clubBook} />
          <div style={{ marginTop: 10 }}><ReactionBarStatic post={post} onReact={onReact} /></div>
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: '16px 18px calc(20px + var(--sab,0px))', WebkitOverflowScrolling: 'touch' }}>
          <CommentsLoadingOrThread post={post} comments={comments} commentsLoading={commentsLoading} viewerId={viewerId}
            title={post.kind === 'question' ? 'Respostas' : isLicao(post) ? 'Dúvidas & explicações' : 'Leituras'}
            onAddComment={onAddComment} onEditComment={onEditComment} onDeleteComment={onDeleteComment} onReactComment={onReactComment} />
        </div>
      </div>
    </Sheet>
  );
}

export function PostPreview({ post, clubBook }: any) {
  if (isLicao(post)) {
    const { concept } = parseLicao(post.text);
    return (
      <div style={{ marginTop: 10, display: 'flex', alignItems: 'center', gap: 10 }}>
        <span style={{ width: 30, height: 30, borderRadius: 9, background: 'var(--lapis-soft)', display: 'grid', placeItems: 'center', flexShrink: 0 }}><IcoTeach size={16} style={{ color: 'var(--lapis)' }} /></span>
        <div style={{ minWidth: 0 }}>
          <div className="mono" style={{ fontSize: 10, color: 'var(--ink-4)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{post.author?.name} ensina</div>
          <div className="serif" style={{ fontSize: 19, color: 'var(--ink)', lineHeight: 1.2 }}>{concept}</div>
        </div>
      </div>
    );
  }
  if (post.kind === 'citation') {
    return (
      <div style={{ marginTop: 10 }}>
        <blockquote className="serif" style={{ margin: 0, fontSize: 20, lineHeight: 1.3, color: 'var(--ink)', paddingLeft: 14, borderLeft: '2px solid var(--plum)' }}>{post.text}</blockquote>
        <div className="mono" style={{ fontSize: 11, color: 'var(--ink-3)', marginTop: 6 }}>{post.author?.name}{post.page ? ` · p. ${post.page}` : ''}</div>
      </div>
    );
  }
  if (post.kind === 'question') {
    return <h3 style={{ margin: '10px 0 0', fontSize: 18, lineHeight: 1.35, color: 'var(--ink)', fontWeight: 600 }}>{post.text}</h3>;
  }
  const txt = (post.text || post.prompt || '').replace(/[#>*-]/g, '').split('\n').filter(Boolean)[0] || '';
  return (
    <div style={{ marginTop: 10, display: 'flex', alignItems: 'center', gap: 10 }}>
      <Avatar user={post.author} size={28} />
      <div style={{ fontSize: 14, color: 'var(--ink-2)', lineHeight: 1.45, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{txt}</div>
    </div>
  );
}

/* ---------- MENU DE GERENCIAR ---------- */
export function MenuSheet({ post, onClose, onEdit, onDelete, onReport, canManage }: any) {
  const Row = ({ Icon, label, danger, onClick, sub }: any) => (
    <button onClick={onClick} style={{ display: 'flex', alignItems: 'center', gap: 14, width: '100%', padding: '15px 20px', textAlign: 'left', color: danger ? '#E0796B' : 'var(--ink)', fontSize: 15.5, fontWeight: 500 }}>
      <Icon size={20} style={{ color: danger ? '#E0796B' : 'var(--ink-3)' }} />
      <span style={{ flex: 1 }}>{label}{sub && <span style={{ display: 'block', fontSize: 12, color: 'var(--ink-4)', fontWeight: 400, marginTop: 1 }}>{sub}</span>}</span>
    </button>
  );
  return (
    <Sheet open={true} onClose={onClose} label="Opções" maxHeight="70vh">
      <div style={{ padding: '6px 0 calc(14px + var(--sab,0px))' }}>
        <div style={{ padding: '4px 20px 10px' }}><TypeBadge kind={post.kind} /></div>
        <div style={{ borderTop: '1px solid var(--line)' }}>
          {canManage && <Row Icon={IcoEdit} label="Editar" onClick={() => { onClose(); onEdit(post); }} />}
          {canManage && <div style={{ height: 1, background: 'var(--line)', margin: '0 20px' }} />}
          {canManage && <Row Icon={IcoTrash} label="Excluir" danger onClick={() => { onClose(); onDelete(post); }} />}
          {canManage && <div style={{ height: 1, background: 'var(--line)', margin: '0 20px' }} />}
          <Row Icon={IcoFlag} label="Denunciar" sub="Conteúdo impróprio ou abusivo" onClick={() => { onClose(); onReport(post); }} />
        </div>
      </div>
    </Sheet>
  );
}

/* ---------- EDIÇÃO ---------- */
const editArea = { width: '100%', marginTop: 8, background: 'var(--paper)', border: '1px solid var(--line-strong)', borderRadius: 12, padding: '12px 14px', color: 'var(--ink)', fontSize: 15, lineHeight: 1.55, resize: 'none', outline: 'none', fontFamily: 'var(--font-sans)' };
export function EditSheet({ post, onClose, onSave }: any) {
  const [text, setText] = useState(post.text || post.prompt || post.comment || '');
  const [comment, setComment] = useState(post.comment || '');
  const isCitation = post.kind === 'citation';
  const isQbox = post.kind === 'question-box';
  const lockNote = (post.kind === 'quiz' || post.kind === 'question-box');
  return (
    <Sheet open={true} onClose={onClose} label="Editar" maxHeight="88vh">
      <div style={{ display: 'flex', flexDirection: 'column', maxHeight: '88vh' }}>
        <div style={{ display: 'flex', alignItems: 'center', padding: '8px 18px 14px', borderBottom: '1px solid var(--line)' }}>
          <button onClick={onClose} style={{ color: 'var(--ink-3)', fontSize: 15, fontWeight: 500 }}>Cancelar</button>
          <div style={{ flex: 1, textAlign: 'center', fontWeight: 600, fontSize: 15 }}>Editar {POST_TYPES[post.kind]?.short.toLowerCase()}</div>
          <PrimaryBtn onClick={() => onSave(post, isCitation ? { text, comment } : isQbox ? { prompt: text } : { text })} style={{ padding: '8px 16px', fontSize: 14 }}>Salvar</PrimaryBtn>
        </div>
        <div style={{ padding: 18, overflowY: 'auto' }}>
          {lockNote && (
            <div style={{ display: 'flex', gap: 10, padding: '11px 13px', background: 'var(--paper-3)', borderRadius: 12, marginBottom: 14, fontSize: 12.5, color: 'var(--ink-3)' }}>
              <IcoLock size={15} style={{ flexShrink: 0, marginTop: 1 }} />
              {post.kind === 'quiz' ? 'Estrutura do quiz (opções/gabarito) exige excluir e recriar. Aqui você edita só o texto.' : 'Estrutura da caixa exige excluir e recriar. Aqui você edita só o enunciado.'}
            </div>
          )}
          <label className="mono" style={{ fontSize: 11, color: 'var(--ink-3)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{isCitation ? 'Trecho citado' : isQbox ? 'Enunciado' : 'Texto'}</label>
          <textarea value={text} onChange={(e) => setText(e.target.value)} rows={isCitation ? 3 : 8} style={editArea} />
          {isCitation && (
            <>
              <label className="mono" style={{ fontSize: 11, color: 'var(--ink-3)', textTransform: 'uppercase', letterSpacing: '0.05em', marginTop: 16, display: 'block' }}>Seu comentário</label>
              <textarea value={comment} onChange={(e) => setComment(e.target.value)} rows={4} style={editArea} />
            </>
          )}
        </div>
      </div>
    </Sheet>
  );
}

/* ---------- PERGUNTAR ANÔNIMO ---------- */
export function AskAnonymousSheet({ post, onClose, onSubmit }: any) {
  const [text, setText] = useState('');
  const ref = useRef<any>(null);
  useEffect(() => { ref.current && ref.current.focus(); }, []);
  return (
    <Sheet open={true} onClose={onClose} label="Pergunta anônima" maxHeight="80vh">
      <div style={{ padding: '8px 18px calc(20px + var(--sab,0px))' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
          <div style={{ width: 40, height: 40, borderRadius: 12, background: 'var(--sage-soft)', display: 'grid', placeItems: 'center' }}><IcoLock size={20} style={{ color: 'var(--sage)' }} /></div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 600, fontSize: 15.5, color: 'var(--ink)' }}>Pergunta anônima</div>
            <div style={{ fontSize: 12.5, color: 'var(--ink-3)' }}>Nem o líder vê quem perguntou.</div>
          </div>
          <button onClick={onClose} style={{ color: 'var(--ink-4)', padding: 4 }}><IcoClose size={20} /></button>
        </div>
        <div style={{ padding: '11px 13px', background: 'var(--paper)', borderRadius: 12, marginBottom: 12, fontSize: 13.5, color: 'var(--ink-2)', borderLeft: '2px solid var(--sage)' }}>{post.prompt}</div>
        <textarea ref={ref} value={text} onChange={(e) => setText(e.target.value)} maxLength={1000} rows={5}
          placeholder="O que ficou confuso? Pergunte do seu jeito…" style={{ width: '100%', background: 'var(--paper)', border: '1px solid var(--line-strong)', borderRadius: 14, padding: '14px', color: 'var(--ink)', fontSize: 15.5, lineHeight: 1.55, resize: 'none', outline: 'none', minHeight: 120 }} />
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 14 }}>
          <span className="mono" style={{ fontSize: 11, color: 'var(--ink-4)' }}>{text.length}/1000</span>
          <PrimaryBtn disabled={!text.trim()} onClick={() => onSubmit(post, text.trim())}><IcoSend size={16} />Enviar anônima</PrimaryBtn>
        </div>
      </div>
    </Sheet>
  );
}

function SectionLabel({ children }: any) {
  return <div className="mono" style={{ fontSize: 11, color: 'var(--ink-3)', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 11 }}>{children}</div>;
}

/* ---------- PAINEL ADMIN DA CAIXA ---------- */
export function QboxAdminSheet({ post, questions, loading, onClose, onAnswer }: any) {
  const [answering, setAnswering] = useState<any>(null);
  const [answer, setAnswer] = useState('');
  const open = (questions || []).filter((q: any) => q.state === 'open');
  const done = (questions || []).filter((q: any) => q.state !== 'open');
  return (
    <FullView onClose={onClose}
      title={<div><div style={{ fontWeight: 600, fontSize: 15, color: 'var(--ink)' }}>Caixa de perguntas</div><div className="mono" style={{ fontSize: 10.5, color: 'var(--ink-3)' }}>{open.length} abertas · {done.length} respondidas</div></div>}>
      <div style={{ padding: '16px 18px calc(40px + var(--sab,0px))' }}>
        <div style={{ padding: '12px 14px', background: 'var(--ember-soft)', borderRadius: 12, marginBottom: 18, display: 'flex', gap: 10, alignItems: 'flex-start' }}>
          <IcoCrown size={17} style={{ color: 'var(--ember)', flexShrink: 0, marginTop: 1 }} />
          <div style={{ fontSize: 13, color: 'var(--ink-2)', lineHeight: 1.5 }}>Responder gera um post <strong style={{ color: 'var(--ember-2)' }}>Resposta do líder</strong> no feed. Perguntas são anônimas.</div>
        </div>
        {loading && <div style={{ textAlign: 'center', color: 'var(--ink-4)', padding: 20 }}>Carregando…</div>}
        {open.length > 0 && <SectionLabel>Abertas · {open.length}</SectionLabel>}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 22 }}>
          {open.map((q: any) => (
            <div key={q.id} style={{ background: 'var(--paper-2)', border: '1px solid var(--line)', borderRadius: 14, padding: 14 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 8 }}>
                <IcoLock size={13} style={{ color: 'var(--ink-4)' }} />
                <span className="mono" style={{ fontSize: 10.5, color: 'var(--ink-4)' }}>anônimo · {q.askedAt}</span>
              </div>
              <div style={{ fontSize: 15, color: 'var(--ink)', lineHeight: 1.45, fontWeight: 500 }}>{q.text}</div>
              {answering === q.id ? (
                <div style={{ marginTop: 12 }}>
                  <textarea autoFocus value={answer} onChange={(e) => setAnswer(e.target.value)} maxLength={4000} rows={4} placeholder="Escreva a resposta do líder…" style={{ width: '100%', background: 'var(--paper)', border: '1px solid var(--line-strong)', borderRadius: 12, padding: '12px', color: 'var(--ink)', fontSize: 14.5, lineHeight: 1.55, resize: 'none', outline: 'none' }} />
                  <div style={{ display: 'flex', gap: 8, marginTop: 10, justifyContent: 'flex-end' }}>
                    <button onClick={() => { setAnswering(null); setAnswer(''); }} style={{ padding: '9px 14px', color: 'var(--ink-3)', fontSize: 14, fontWeight: 500 }}>Cancelar</button>
                    <PrimaryBtn disabled={!answer.trim()} onClick={() => { onAnswer(post, q, answer.trim()); setAnswering(null); setAnswer(''); }} style={{ padding: '9px 16px', fontSize: 14 }}><IcoCrown size={15} />Responder</PrimaryBtn>
                  </div>
                </div>
              ) : (
                <button onClick={() => setAnswering(q.id)} style={{ marginTop: 11, display: 'inline-flex', alignItems: 'center', gap: 7, padding: '8px 14px', borderRadius: 10, background: 'var(--ember)', color: '#1a1208', fontSize: 13.5, fontWeight: 600 }}><IcoReply size={15} />Responder</button>
              )}
            </div>
          ))}
        </div>
        {done.length > 0 && <SectionLabel>Respondidas · {done.length}</SectionLabel>}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {done.map((q: any) => (
            <div key={q.id} style={{ background: 'var(--paper)', borderRadius: 12, padding: '12px 14px', opacity: 0.75 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 5 }}>
                <IcoCheck size={14} style={{ color: 'var(--sage)' }} /><span className="mono" style={{ fontSize: 10.5, color: 'var(--sage)' }}>respondida</span>
              </div>
              <div style={{ fontSize: 14, color: 'var(--ink-2)', lineHeight: 1.4 }}>{q.text}</div>
            </div>
          ))}
        </div>
      </div>
    </FullView>
  );
}

/* ---------- DETALHE DO INSIGHT FINAL ---------- */
export function InsightDetailScreen({ post, comments, commentsLoading, milestone, onClose, onReact, onAddComment, onEditComment, onDeleteComment, onReactComment, onOpenMilestoneFeed, viewerId }: any) {
  const { onOpenProfile } = useStudy() || {};
  const goAuthor = (e: any) => { e?.stopPropagation?.(); if (onOpenProfile && post.author?.id) onOpenProfile(post.author.id); };
  return (
    <FullView onClose={onClose} title={<span className="mono" style={{ fontSize: 11, color: 'var(--ember-2)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Insight Final</span>}>
      <div style={{ position: 'relative', padding: '10px 22px 0', background: 'linear-gradient(180deg, color-mix(in oklab, var(--ember) 10%, var(--paper)), var(--paper) 70%)' }}>
        <div style={{ display: 'grid', placeItems: 'center', paddingTop: 14 }}>
          <div style={{ width: 64, height: 64, borderRadius: 20, background: 'var(--ember-soft)', display: 'grid', placeItems: 'center', boxShadow: '0 8px 30px rgba(232,122,59,0.25)' }}>
            <IcoTrophy size={34} style={{ color: 'var(--ember)' }} />
          </div>
        </div>
        {post.milestoneLabel && <div className="mono" style={{ textAlign: 'center', fontSize: 11, color: 'var(--sage)', textTransform: 'uppercase', letterSpacing: '0.06em', marginTop: 16, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 6 }}>
          <IcoCheck size={14} />{post.milestoneLabel}
        </div>}
        <h1 className="serif" style={{ textAlign: 'center', margin: '8px 0 20px', fontSize: 32, lineHeight: 1.28, color: 'var(--ink)' }}>{post.title}</h1>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 9, paddingBottom: 18 }}>
          <span onClick={goAuthor} style={{ cursor: onOpenProfile ? 'pointer' : 'default', lineHeight: 0, flexShrink: 0 }}><Avatar user={post.author} size={28} ring="var(--ember)" /></span>
          <span onClick={goAuthor} style={{ fontSize: 13.5, color: 'var(--ink-2)', fontWeight: 600, cursor: onOpenProfile ? 'pointer' : 'default' }}>{post.author?.name}</span>
          <span className="mono" style={{ fontSize: 11, color: 'var(--ink-4)' }}>· {post.timeAgo}</span>
        </div>
      </div>
      <div style={{ padding: '8px 22px', fontSize: 17, lineHeight: 1.74 }}>
        <RichText text={post.text} />
      </div>
      {milestone && (
        <div style={{ padding: '8px 22px 0' }}>
          <button onClick={() => onOpenMilestoneFeed(milestone)} style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, padding: '14px 16px', borderRadius: 14, background: 'var(--paper-2)', border: '1px solid var(--line)' }}>
            <span style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
              <span className="mono" style={{ fontSize: 10.5, color: 'var(--ink-4)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>marco {milestone.n}</span>
              <span style={{ fontSize: 14.5, color: 'var(--ink)', fontWeight: 600 }}>Ver todos os {milestone.totalPosts} estudos</span>
            </span>
            <IcoChevron size={18} style={{ color: 'var(--ink-3)' }} />
          </button>
        </div>
      )}
      <div style={{ padding: '16px 22px', margin: '16px 0 0', borderTop: '1px solid var(--line)' }}>
        <ReactionBarStatic post={post} onReact={onReact} />
      </div>
      <div style={{ padding: '8px 22px calc(40px + var(--sab,0px))', borderTop: '1px solid var(--line)' }}>
        <CommentsLoadingOrThread post={post} comments={comments} commentsLoading={commentsLoading} viewerId={viewerId} title="Discussão"
          onAddComment={onAddComment} onEditComment={onEditComment} onDeleteComment={onDeleteComment} onReactComment={onReactComment} />
      </div>
    </FullView>
  );
}

/* ---------- TELA DE TEMA (Fios) ---------- */
export function ThemeView({ tag, posts, onClose }: any) {
  const matched = (posts || []).filter((p: any) => (p.tags || []).includes(tag));
  return (
    <FullView onClose={onClose} title={<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}><IcoTheme size={17} style={{ color: 'var(--ember)' }} /><span style={{ fontWeight: 600, fontSize: 15.5, color: 'var(--ink)' }}>{tag}</span></div>}>
      <div style={{ padding: '18px 16px calc(40px + var(--sab,0px))' }}>
        <div style={{ padding: '16px 18px', borderRadius: 16, background: 'linear-gradient(160deg, var(--ember-soft), var(--paper-2))', border: '1px solid var(--line)', marginBottom: 18 }}>
          <div className="mono" style={{ fontSize: 11, color: 'var(--ember-2)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Fio de estudo</div>
          <h2 className="serif" style={{ margin: '6px 0 8px', fontSize: 28, lineHeight: 1.24, color: 'var(--ink)' }}>{tag}</h2>
          <p style={{ margin: 0, fontSize: 14, color: 'var(--ink-2)', lineHeight: 1.55 }}>
            Tudo que o clube já forjou sobre <strong style={{ color: 'var(--ink)' }}>{(tag || '').toLowerCase()}</strong> — reunido pra você revisitar e aprofundar. {matched.length} contribuições.
          </p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {matched.map((p: any) => <PostCard key={p.id} post={p} />)}
        </div>
        {matched.length === 0 && <div style={{ textAlign: 'center', color: 'var(--ink-4)', padding: 30 }}>Nada neste fio ainda.</div>}
      </div>
    </FullView>
  );
}
